import { openAlertModal } from 'admin/actions/alert-modal';
import { showPaybox } from 'admin/actions/devices';
import Breadcrumb from 'admin/components/shared/Breadcrumb';
import Button from 'admin/components/shared/Button';
import { formatNum, formatTopupMode, formatUUID } from 'admin/utils';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';
import { bindActionCreators } from 'redux';
import styles from './styles.scss';

class Paybox extends Component {
  componentWillMount() {
    const { id } = this.props.match.params;
    this.props.showPaybox(id);
  }

  componentWillUpdate(newProps) {
    if (newProps.api_error !== this.props.api_error) {
      const getMessage = (e) => {
        const { type, message } = e;
        switch (type) {
          case 'account_not_accessible':
            return 'アカウントにアクセスできません';
          default:
            if (message === 'Not Found') {
              return '見つかりませんでした';
            }
            return '処理に失敗しました';
        }
      };
      this.props.openAlertModal({
        body: <p>{getMessage(newProps.api_error)}</p>,
        confirmText: 'もどる',
        onConfirm: () => {
          this.props.history.goBack();
        },
        useCancel: false,
      });
    }
  }

  back = () => {
    this.props.history.goBack();
  };

  render() {
    const crumb = [
      { value: 'ホーム', href: '/', active: false },
      { value: '各種設定', href: '', active: true },
      { value: 'デバイス管理', href: '/settings/devices', active: false },
      { value: 'ペイボックス詳細', href: '', active: true },
    ];
    return (
      <div>
        <div>
          <Breadcrumb items={crumb} />
          <div>
            <div styleName="row">
              <div styleName="cat-label">ペイボックス設定</div>
              <div styleName="cat-val">
                <div styleName="row">
                  <div styleName="label">製造番号</div>
                  <div styleName="val">{this.props.paybox.serial_number}</div>
                </div>
                <div styleName="row">
                  <div styleName="label">ハードウェアver</div>
                  <div styleName="val">{this.props.paybox.hardware_ver}</div>
                </div>
                <div styleName="row">
                  <div styleName="label">チャージ機能</div>
                  <div styleName="val">{formatTopupMode(this.props.paybox.topup_mode)}</div>
                </div>
                <div styleName="row">
                  <div styleName="label">最大入力可能金額</div>
                  <div styleName="val">¥{formatNum(this.props.paybox.transfer_limit)}</div>
                </div>
              </div>
            </div>
            <div styleName="row">
              <div styleName="cat-label">設置先設定</div>
              <div styleName="cat-val">
                <div styleName="row">
                  <div styleName="label">設置店舗名</div>
                  <div styleName="val">
                    <Link to={`/shops/${this.props.paybox.shop_id}`}>
                      {this.props.paybox.shop_name}
                    </Link>
                  </div>
                </div>
                <div styleName="row">
                  <div styleName="label">マネー名</div>
                  <div styleName="val">{this.props.paybox.money_name}</div>
                </div>
                <div styleName="row">
                  <div styleName="label">端末ID</div>
                  <div styleName="val">{formatUUID(this.props.paybox.terminal_id)}</div>
                </div>
                <div styleName="row">
                  <div styleName="label">状態</div>
                  <div styleName="val">
                    {this.props.paybox.is_invalidated ? <div>無効</div> : <div>有効</div>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div styleName="button-group">
            <Button onClick={this.back} color="gray">
              戻る
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

Paybox.defaultProps = {
  user: {},
  paybox: {},
  api_error: null,
};

const mapStateToProps = (state) => ({
  user: state.user,
  paybox: state.device.paybox,
  api_error: state.apiError.error,
});

Paybox.propTypes = {
  user: PropTypes.object,
  showPaybox: PropTypes.func.isRequired,
  openAlertModal: PropTypes.func.isRequired,
  paybox: PropTypes.shape({
    id: PropTypes.number,
    serial_number: PropTypes.string,
    hardware_ver: PropTypes.string,
    status: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    terminal_id: PropTypes.string,
    is_invalidated: PropTypes.bool,
    account_id: PropTypes.string,
    shop_name: PropTypes.string,
    shop_id: PropTypes.string,
    organization_name: PropTypes.string,
    organization_code: PropTypes.string,
    account_name: PropTypes.string,
    money_name: PropTypes.string,
    topup_mode: PropTypes.string,
    transfer_limit: PropTypes.number,
  }),
  match: PropTypes.shape({
    params: PropTypes.object,
  }).isRequired,
  api_error: PropTypes.object,
  history: ReactRouterPropTypes.history.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      showPaybox,
      openAlertModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(Paybox, styles));
